import React from 'react';
import { Link } from 'react-router-dom';
import styles from './CTASection.module.css';

const CTASection = ({
  title = 'Optimized for Care. Engineered for Compliance.',
  description = 'Our platform is built with both healthcare professionals and clients in mind. The user-friendly interface ensures that you can navigate seamlessly through patient records, appointments, and medical histories with ease.',
  buttonText = 'Book a demo',
  buttonHref = '/book-demo',
}) => {
  return (
    <section className={styles.cta}>
      <div className={styles.cta__container}>
        <div className={styles.cta__card}>
          <div className={styles.cta__content}>
            <h2 className={styles.cta__title}>{title}</h2>
            <p className={styles.cta__description}>{description}</p>
            <Link to={buttonHref} className={styles.cta__button}>{buttonText}</Link>
          </div>
          <img src="/assets/website/CTAImage.png" alt="" className={styles.cta__image} />
        </div>
      </div>
    </section>
  );
};

export default CTASection;
